export default function CtaSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">
          Начни покупать умнее
        </h2>
        <p className="mt-4 text-base md:text-lg text-foreground-500 font-body">
          Присоединяйтесь к тысячам довольных клиентов YOYBUY Sheet
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span>Перейти на YOYBUY</span>
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>

      <div className="mt-16 max-w-7xl mx-auto flex flex-wrap justify-center gap-4 md:gap-6">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20white%20sneakers%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-1&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20beige%20hoodie%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-2&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20leather%20bag%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-3&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20baseball%20cap%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-4&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20accessories%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-5&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20perfume%20bottle%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style%2C%20cutout%20presentation&width=400&height=400&seq=cta-prod-6&orientation=squarish"
          alt=""
          className="w-20 h-20 md:w-24 md:h-24 object-cover object-top rounded-xl"
          loading="lazy"
        />
      </div>
    </section>
  );
}